import Repository from "./Repository";
const subscribe = "/payment/subscribe";
const checkCoupon = "/payment/coupon";
const updateCard = "/payment/card";
const userSubscription = "/payment/currentSubscription";
const resumeSubscription = "/payment/resumeSubscription";

const SubscriptionRepository = {
  subscribePlan(payload) {
    return Repository.post(`${subscribe}`, payload);
  },
  cancelSubscribePlan(user_id) {
    return Repository.delete(`/payment/subscribe/${user_id}`);
  },
  fetchCustomer(stripe_customer_id) {
    return Repository.get(`/payment/customer/${stripe_customer_id}`);
  },
  validateCoupon(coupon) {
    return Repository.post(`${checkCoupon}`, { coupon });
  },
  updateCard(payload) {
    return Repository.post(`${updateCard}`, payload);
  },
  userSubscription(customerId) {
    return Repository.post(`${userSubscription}`, { customerId });
  },
  // No body: the backend finds the customer from the signed-in user's token.
  resumeSubscription() {
    return Repository.post(`${resumeSubscription}`);
  },
};

export default SubscriptionRepository;
